export default ({intercomManager}) => ({
    // Namespace does make sense i this case, it much easier to use more explicit names.
    // This allows to easier mapping in Vue components.
    namespaced: false,
    actions: {
        initializeIntercom({getters}) {
            intercomManager.initialize(getters);
        },
        logoutIntercom() {
            intercomManager.logout();
        },
        updateIntercomUser() {
            intercomManager.updateUser();
        },
        triggerIntercomEvent(context, event) {
            if (!event.name) {
                throw new Error('triggerIntercomEvent requires a name');
            }

            if (intercomManager.isTrackingActive && intercomManager.isBooted) {
                intercomManager.client('trackEvent', event.name, event.meta);
                setTimeout(() => {
                    intercomManager.client('update', {last_request_at: parseInt((new Date()).getTime() / 1000, 10)});
                }, 500);
            }
        },
    },
});
